import React, { createContext, useContext, useEffect, useSyncExternalStore } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { platformSession, tenantSession } from './session';
import { loginPath, safeReturnTo, takeSsoDestination } from './routes';

const AuthContext = createContext(null);
export function AuthProvider({ type = 'tenant', session: supplied, children }) {
  const session = supplied || (type === 'platform' ? platformSession : tenantSession);
  const state = useSyncExternalStore(session.subscribe, session.getSnapshot);
  useEffect(() => { session.restore(); }, [session]);

  return <AuthContext.Provider value={{ ...state, session }}>{children || <Outlet />}</AuthContext.Provider>;
}
export const useAuth = () => useContext(AuthContext);

export function RequireAuth({ role }) {
  const auth = useAuth(); const location = useLocation();
  if (auth.status === 'loading' || auth.status === 'authenticating')
    return <SessionLoading />;
  if (auth.status !== 'authenticated') {
    let pathname;
    try { pathname = decodeURI(location.pathname); } catch { pathname = ''; }
    return <Navigate replace to={loginPath(auth.type)} state={{ returnTo: safeReturnTo(pathname, auth.type), reason: auth.reason }} />;
  }
  if ((role && !auth.user.roles.includes(role)) || (auth.type === 'tenant' && auth.user.roles.includes('COBYGO_ADMIN'))) {
    return <AccessDenied />;
  }
  return <Outlet />;
}
export function SessionLoading() { return <div className="auth-status" role="status">Restoring your session…</div>; }
export function AccessDenied() {
  return <section className="auth-status"><h1>Access denied</h1><p>Your account does not have access to this area.</p><SignOutButton /></section>;
}
export function SignOutButton() {
  const { session, type } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    let warning;
    try { await session.logout(); } catch { warning = 'logout_failed'; }
    navigate(loginPath(type), { replace: true, state: { reason: warning || 'signed_out' } });
  };

  return <button className="auth-link-button" onClick={handleSignOut}>Sign out</button>;
}
export function SsoReentry({ children }) {
  const { status } = useAuth(); const navigate = useNavigate();
  useEffect(() => {
    if (status === 'authenticated') {
      const target = takeSsoDestination();
      if (target) navigate(target, { replace: true });
    }
  }, [status, navigate]);
  return children || <Outlet />;
}
